import { ApolloError, useMutation, useQuery, useSubscription } from "@apollo/client";
import { ICluster, IClusterEntity } from "./ClusterEntityInterfaces";
import {
    getClusters,
    softDeleteCluster,
    subscribeClusterDetailsClusterCodeBO,
    updateClusterCode,
    upsertCluster,
} from "api/queries/clusterAPI";
import { useEffect, useState } from "react";

export const ClusterEntity: IClusterEntity = {
    GetClusters: (millId: number) => {
        const { loading, error, data, refetch } = useQuery(getClusters, {
            fetchPolicy: "no-cache",
            variables: { mill_id: millId },
        });

        const [clusters, setClusters] = useState<ICluster[]>([]);
        const [apolloQueryError, setApolloQueryError] = useState<ApolloError | undefined>(undefined);

        useEffect(() => {
            if (data) {
                const clustersArray: ICluster[] = data.cluster;
                setClusters(clustersArray);
            }
            if (error) {
                setApolloQueryError(error);
            }
        }, [data, error]);

        return { loading, clusters, apolloQueryError, refetch };
    },
    AddOrUpdateCluster: () => {
        const [addOrUpdateCluster, { error }] = useMutation(upsertCluster);
        return { apolloMutationError: error, addOrUpdateCluster };
    },
    SubscribeClusterCode: (clusterCodeId: number) => {
        const { loading, error, data } = useSubscription(subscribeClusterDetailsClusterCodeBO, {
            variables: { cluster_id: clusterCodeId },
        });
        const [cluster, setCluster] = useState<ICluster[]>([]);
        const [apolloQueryError, setApolloQueryError] = useState<ApolloError | undefined>(undefined);

        useEffect(() => {
            if (data) {
                const clusterArray: ICluster[] = data.cluster;
                setCluster(clusterArray);
            }
            if (error) {
                setApolloQueryError(error);
            }
        }, [data, error]);

        return { loading, cluster, apolloQueryError };
    },
    UpdateClusterCode: () => {
        const [refreshClusterCode, { error }] = useMutation(updateClusterCode);
        return { apolloMutationError: error, refreshClusterCode };
    },
    SoftDeleteCluster: () => {
        const [deleteCluster, { error }] = useMutation(softDeleteCluster, { fetchPolicy: "no-cache" });

        return { apolloMutationError: error, deleteCluster };
    },
};
